// ================================================
// Datei: src/components/Navbar.jsx
// ================================================

import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import "../styles/navbar.css";

export default function Navbar() {

	// ============================================================
	// STATE
	// ============================================================

	const [open, setOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	// 🔥 NEU: erzwingt Re-Render bei Back Button
	const [refresh, setRefresh] = useState(0);

	const { pathname } = useLocation();
	const navigate = useNavigate();

	// ============================================================
	// 🔥 AUTH STATE (direkt aus localStorage → bewusst so gelöst)
	// ============================================================

	const token = localStorage.getItem("token");
	const isLoggedIn = !!token;
	const username = localStorage.getItem("username");

	// ============================================================
	// SCROLL EFFECT (ERWEITERT)
	// ============================================================

	const [darkMode, setDarkMode] = useState(false); // 🔥 NEU

	useEffect(() => {

		const onScroll = () => {

			const scrollY = window.scrollY;

			// bestehend
			setScrolled(scrollY > 80);

			// 🔥 NEU → Dark Mode aktivieren
			setDarkMode(scrollY > 40);

		};

		window.addEventListener("scroll", onScroll);

		return () => window.removeEventListener("scroll", onScroll);

	}, []);

	// ============================================================
	// 🔥 BACK BUTTON FIX (SAUBER)
	// ============================================================
	useEffect(() => {

		const handlePopState = () => {

			const token = localStorage.getItem("token");

			if (token) {
				console.log("🔙 Back Button erkannt → Logout wird ausgeführt");
				handleLogout();
			}
		};

		window.addEventListener("popstate", handlePopState);

		return () => {
			window.removeEventListener("popstate", handlePopState);
		};

	},);

	// ============================================================
	// LOGOUT
	// ============================================================

	const handleLogout = () => {

		localStorage.clear();
		sessionStorage.clear();

		// 🔥 wichtig: replace verhindert zurückspringen
		navigate("/", { replace: true });

	};

	const toggleAriaLabel = open ? "Menü schließen" : "Menü öffnen";

	// ============================================================
	// RENDER
	// ============================================================

	return (

		<nav className={`navbar ${open ? "open" : ""} ${scrolled ? "scrolled" : ""} ${darkMode ? "dark" : ""}`}>

			<div className="nav-container">

				{/* BRAND */}
				<div className="brand">
					FDA<span>•</span>FestivalPortal
				</div>

				{/* HAMBURGER */}
				<button
					className="nav-toggle"
					aria-label={toggleAriaLabel}
					aria-expanded={open}
					onClick={() => setOpen((prev) => !prev)}
				>
					<span />
					<span />
					<span />
				</button>

				{/* NAV LINKS */}
				<ul className="nav-links" onClick={() => setOpen(false)}>

					<li>
						{!isLoggedIn ? (

							<Link to="/" className={pathname === "/" ? "active" : ""}>
								Startseite
							</Link>

						) : (

							<div className="user-info">

								{/* 🔥 Libelle */}
								<img
									src={`${process.env.PUBLIC_URL}/icons/libelle.svg`}
									alt="Libelle"
									className="avatar"
								/>

								<span className="username">
									{username}
								</span>

							</div>

						)}
					</li>

					{!isLoggedIn && (
						<li>
							<Link to="/register" className={pathname === "/register" ? "active" : ""}>
								Registrieren
							</Link>
						</li>
					)}

					<li>
						{!isLoggedIn ? (

							<Link to="/login" className={pathname === "/login" ? "active" : ""}>
								Login
							</Link>

						) : (

							<button onClick={handleLogout} className="logout-button">
								Logout
							</button>

						)}
					</li>

				</ul>

			</div>

		</nav>

	);
}